import { HdButtonGroupComponent } from './hd-button-group.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgZorroAntdModule } from 'ng-zorro-antd';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgZorroAntdModule
  ],
  declarations: [HdButtonGroupComponent],
  exports: [HdButtonGroupComponent]
})
export class HdButtonGroupModule { }
